import { client } from './client'
import type { WorkItemAttachment, PagedResult, PaginationParams } from '@/types'

export const workItemAttachmentsApi = {
  getByWorkItem: (projectId: string, workItemId: string, params?: PaginationParams) =>
    client.get<PagedResult<WorkItemAttachment>>(
      `/projects/${projectId}/work-items/${workItemId}/attachments`,
      { params }
    ).then(r => r.data),

  upload: (projectId: string, workItemId: string, files: File[]) => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))
    return client.post<{ attachmentIds: string[] }>(
      `/projects/${projectId}/work-items/${workItemId}/attachments/upload`,
      formData,
      { headers: { 'Content-Type': undefined } }
    ).then(r => r.data)
  },

  delete: (projectId: string, workItemId: string, attachmentId: string) =>
    client.delete(`/projects/${projectId}/work-items/${workItemId}/attachments/${attachmentId}`),

  getDownloadUrl: (projectId: string, workItemId: string, attachmentId: string) =>
    client.get<string>(
      `/projects/${projectId}/work-items/${workItemId}/attachments/${attachmentId}/download-url`
    ).then(r => r.data),
}
